'use client';
import { useMemo } from 'react';
import { useSession } from 'next-auth/react';
import { User } from 'next-auth';

export function useUser(): UserAuthenticationStatus {
  const { data, status } = useSession();

  const loading = status === 'loading';
  const user: User | null = data?.user ?? null;

  return useMemo(() => ({ loading, authenticatedUser: user }), [loading, user]);
}

interface UserAuthenticationStatus {
  loading: boolean;
  authenticatedUser: User | null;
}
